import React, { useEffect, useState } from "react";
import axios from "axios";
import Env from "../runtimeEnv";

export default function MeetingGroupPicker({ clientEmails, therapistEmail, value, onChange }) {
  const [groups, setGroups] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const query = JSON.stringify({ clientEmails: clientEmails.map(e => (e || "").trim().toLowerCase()).filter(Boolean), therapistEmail });
  useEffect(() => { setGroups([]); setMessage(""); onChange(""); }, [query, onChange]);
  useEffect(() => {
    if (!loading) return;
    let active = true;
    axios.post(`${Env.REACT_APP_PYTHON_API_URL}/api/admin/meeting-groups`, JSON.parse(query), { withCredentials: true })
      .then(({ data }) => {
        if (!active) return;
        setGroups(data.groups);
        setMessage(data.groups.length ? "" : "No sessions found for these clients and therapist.");
      }).catch(error => { if (active) setMessage(error.response?.data?.message || "Unable to load sessions."); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [loading, query]);
  return <div className="space-y-2">
    <p>Choose the existing session to reschedule or rename. To change therapists, schedule a new session.</p>
    <button type="button" className="button-primary" disabled={loading} onClick={() => { onChange(""); setLoading(true); }}>
      {loading ? "Loading sessions..." : "Find sessions"}
    </button>
    {message && <p role="status">{message}</p>}
    <label className="block">Session to update
      <select className="input-field" value={value} onChange={e => onChange(e.target.value)} required>
        <option value="">Select a session</option>
        {groups.map((group, index) => <option key={group.meetingID} value={group.meetingID}>
          {group.meetingName || "Therapy session"} — {group.sessionTime ? new Date(group.sessionTime).toLocaleString() : "No date"} (session {index + 1})
        </option>)}
      </select>
    </label>
  </div>;
}
